import { Util } from '../config/utils';
import { View } from './view';

declare const gtag: any;

export class GoogleAnalyticsView extends View {

    private googleAnalyticsId = '';

    render(googleAnalyticsId: string) {
        this.googleAnalyticsId = googleAnalyticsId;
        this.appendGoogleAnalyticsSourceScript();
        this.appendGoogleAnalyticsGtagScript();
    }

    appendGoogleAnalyticsSourceScript() {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${this.googleAnalyticsId}`;
        document.getElementsByTagName('head')[0].appendChild(script);
    }

    appendGoogleAnalyticsGtagScript() {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.innerHTML = this.getGoogleAnalyticsGtagScript();
        document.getElementsByTagName('head')[0].appendChild(script);
    }

    getGoogleAnalyticsGtagScript = () => {
        let googleAnalyticsGtagScript = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());

        `;
        const dfGaDebugModeParam = Util.getUrlParameter('df-ga-debug-mode', window.location.href) || '';
        googleAnalyticsGtagScript +=
            dfGaDebugModeParam !== null && dfGaDebugModeParam === 'true' ?
                `gtag('config', '${this.googleAnalyticsId}', { 'debug_mode': true });` :
                `gtag('config', '${this.googleAnalyticsId}');`;
        return googleAnalyticsGtagScript;
    }

    getGtagInstance = () => {
        return gtag;
    }

}
